<template>
    <div class="container_table_main_table main_table">
        <div class="counterpart_table_header">
            <div class="search_container">
                <p class="absolute-box is-flex is-justify-content-flex-start is-align-items-center">
                    <span class="ml-3 mr-1">
                        <SearchIcon class="icon_svg" />
                    </span>

                    <input class="input-center" type="text" :placeholder="selectedTypeFile.searcherPlaceHolder"
                        v-model="searchFilter" />
                    <span class="icon-right mr-3" @click="searchFilter = ''">
                        <Ecs v-if="searchFilter" class="icon is-small is-right ecs" />
                    </span>
                </p>
            </div>
        </div>
        <table class="is-full-width color_gray_text">
            <colgroup>
                <col v-for="header in selectedTypeFile.headers" v-bind:key="header.orderKey"
                    :style="'width: ' + header.width + '%;'" />
                <col style="width: 2%" />
            </colgroup>
            <tr>
                <td class="py-3 px-2" v-for="header in selectedTypeFile.headers" v-bind:key="header.orderKey">
                    <span class="table_header_title is-justify-content-center nobreak">
                        {{ header.label }}
                        <SortButton @click="changeOrderGeneric(header.orderKey)" class="ml-1"
                            :globalSortColumn="sortColumn" :column="header.orderKey" :sortDirection="sortDirection">
                        </SortButton>
                    </span>
                </td>
                <td class="">
                </td>
            </tr>
            <template v-for="(entry) in filteredTaxDocs">
                <tr :class="['row', { 'is-disabled-local': entry.cancelled }]" v-show="entry.visible" :key="entry.id">
                    <template v-for="header in selectedTypeFile.headers">
                        <td v-bind:key="header.orderKey" v-if="!['account', 'mother_account'].includes(header.orderKey)"
                            class="py-3 px-2 text_format has-text-centered nobreak">
                            <span v-if="header.orderKey == 'emitted_at'" class="is-capitalized">
                                {{ getFormattedDate(entry.emitted_at, header.formatDate) }}
                            </span>
                            <span v-else-if="header.orderKey == 'amount'">
                                {{ toMoney(getNestedValue(entry, header.nestedPath)) }}
                            </span>
                            <span v-else>
                                {{ getNestedValue(entry, header.nestedPath) }}
                            </span>
                        </td>
                    </template>

                    <td class="py-3 px-2 text_format has-text-centered">
                        <div class="square_pill pill_sin_clasificar nobreak"
                            v-if="!entry.prorate_accounts || entry.prorate_accounts.length == 0">
                            <span v-if="!entry.cancelled">Sin Clasificar</span>
                            <span v-if="entry.cancelled && entry.doc_type != 'Boleta de Honorarios'">
                                Anulado por NC: {{ entry.nc_doc_number }}
                            </span>
                            <span v-if="entry.cancelled && entry.doc_type == 'Boleta de Honorarios'">
                                Anulada
                            </span>
                        </div>
                        <div v-if="entry.prorate_accounts.length > 0">
                            <span class="square_pill pill_mother_account grey_pill nobreak"
                                v-for="(mother_account, index) in getUniqueMotherAccounts(entry.prorate_accounts)"
                                v-bind:key="index">
                                {{ mother_account }}
                            </span>
                        </div>
                    </td>
                    <td class="py-3 px-2 text_format has-text-centered">
                        <div class="square_pill pill_mother_account white_pill nobreak"
                            v-for="account in getUniqueAccounts(entry.prorate_accounts)" v-bind:key="account">
                            {{ account }}
                        </div>
                        <div v-if="!entry.cancelled && (!entry.prorate_accounts || entry.prorate_accounts.length == 0)"
                            class="is-full-width is-flex is-justify-content-center">
                            <span class="square_pill pill_clasificar is-clickable"
                                @click="openAccountByCompanyModal(entry)">
                                <EditPencil class="edit_pencil" />
                                Clasificar
                            </span>

                        </div>

                    </td>
                    <td class="py-3 px-2  has-text-centered is-clickable"
                        v-if="selectedTypeFile.value != 'finiquitos-clf' && !entry.cancelled"
                        @click="openAccountByCompanyModal(entry)">
                        <EditPencil class="mr-1" />
                    </td>
                </tr>
            </template>

        </table>
    </div>
</template>

<script>
import ClassifyAccountAttributes from "@/components/modals/ClassifyAccountAttributes";
import SortButton from "@/components/modals/SortButton.vue";
import Ecs from "@/components/svg/Ecs.vue";
import EditPencil from "@/components/svg/EditPencil.vue";
import SearchIcon from "@/components/svg/SearchIcon.vue";
import { parseToMoney } from "@/utils/currency";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "RemunerationsDocsTable",
    components: {
        SortButton,
        SearchIcon,
        Ecs,
        EditPencil
    },
    data() {
        return {
            searchFilter: '',
            sortColumn: '',
            sortDirection: '',
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            localOrderedTaxDocuments: [],
        }
    },
    computed: {
        ...mapState("classification", ["periodDataSelect"]),
        ...mapState("uploadFiles", ["selectedTypeFile"]),
        filteredTaxDocs() {
            return this.localOrderedTaxDocuments.filter(taxDoc => {
                return this.searchFilter == '' || (taxDoc.companies_involved.alias + " " + taxDoc.companies_involved.counterpart.rut + " " + taxDoc.amount + " " + taxDoc.description).includes(this.searchFilter)
            })
        }
    },
    methods: {
        toMoney: (value) => {
            return parseToMoney(value);
        },
        getFormattedDate(emittedDate, format = 'DD-MM-YYYY') {
            // const date = this.initDateFirstDayMonthByStr(emittedDate)
            return moment(emittedDate).format(format).replace('.', '');
        },
        getNestedValue(obj, path) {
            return path.split('.').reduce((val, key) => (val && val[key]), obj)
        },
        openAccountByCompanyModal(document) {
            try {
                const contraparte = {
                    ci_id: document.companies_involved.id,
                    pay_or_charge: document.document_type,
                    obligation_name: this.selectedTypeFile.value
                }

                this.$buefy.modal.open({
                    ...this.modalDefault,
                    component: ClassifyAccountAttributes,
                    customClass: "classify_modal_width",
                    props: {
                        rangeFromMainScreen: this.periodDataSelect[4].value,
                        counterpart: contraparte,
                    },
                    events: {
                        reloadCounterpart: () => {
                            // this.getDocumentsByFilter(this.selectedPeriod)
                            this.$emit('reloadData')
                        },
                    },
                });
            } catch (err) {
                console.log("error?:", err);
            }
        },
        getUniqueMotherAccounts(prorateAccounts) {
            let motherAccounts = []
            prorateAccounts.map(pr => {
                if (motherAccounts.indexOf(pr.account_plan.level_21.level_2) < 0) {
                    motherAccounts.push(pr.account_plan.level_21.level_2)
                }
            })
            return motherAccounts
        },
        getUniqueAccounts(prorateAccounts) {
            let accounts = []
            prorateAccounts.map(pr => {
                if (accounts.indexOf(pr.account_plan.level_3) < 0) {
                    accounts.push(pr.account_plan.level_3)
                }
            })
            return accounts
        },
        changeDirectionData() {
            if (this.sortDirection == "order") {
                this.sortDirection = "desc";
            } else if (this.sortDirection == "desc") {
                this.sortDirection = "asc";
            } else if (this.sortDirection == "asc") {
                this.sortDirection = "order";
                this.sortColumn = "order";
            }
        },
        sortPartiallyDocs(docsToSort = []) {
            return docsToSort.sort((a, b) => {
                let col_name = this.sortColumn;
                const valA = a[col_name];
                const valB = b[col_name];
                if (col_name == 'amount' && valA == valB) {
                    const dateA = new Date(a['emitted_at'])
                    const dateB = new Date(b['emitted_at'])
                    return this.sortDirection === "asc" ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
                } else if (col_name == 'amount' && valA != valB) {
                    return this.sortDirection === "asc" ? valA - valB : valB - valA;
                } else if (col_name == 'rut' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'rut' && valA != valB) {
                    const compareVal = valA.localeCompare(valB)
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else if (col_name == 'name_counterpart' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'name_counterpart' && valA != valB) {
                    const compareVal = valA.localeCompare(valB)
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else if (col_name == 'counterpart_type' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'counterpart_type' && valA != valB) {
                    const compareVal = valA.localeCompare(valB)
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else if (col_name == 'doc_type' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'doc_type' && valA != valB) {
                    const compareVal = valA.localeCompare(valB)
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else if (col_name == 'emitted_at' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'emitted_at' && valA != valB) {
                    const dateA = new Date(valA)
                    const dateB = new Date(valB)
                    return this.sortDirection === "asc" ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
                } else if (col_name == 'doc_number' && valA == valB) {
                    const dateA = new Date(a['emitted_at'])
                    const dateB = new Date(b['emitted_at'])
                    return this.sortDirection === "asc" ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
                } else if (col_name == 'doc_number' && valA != valB) {
                    const maskedValA = valA.padStart(valB.length, "0");
                    const maskedValB = valB.padStart(valA.length, "0");
                    const compareVal = maskedValA.localeCompare(maskedValB)
                    return this.sortDirection === "asc" ? compareVal : -compareVal;
                } else if (col_name == 'accounts' && valA.length == valB.length && valA.length == 0) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'accounts') {
                    let auxA = valA
                    let auxB = valB;
                    if (auxA.length == 0) {
                        auxA = { level_3: a['accounts_doc'] }
                    }
                    if (auxB.length == 0) {
                        auxB = { level_3: b['accounts_doc'] }
                    }
                    if (auxA.length > 0 && auxB.length == 0) {
                        return 1
                    } else if (auxA.length == 0 && auxB.length > 0) {
                        return -1
                    }
                    if (auxA[0].level_3 == auxB[0].level_3) {
                        const subauxA = a['amount'];
                        const subauxB = b['amount'];
                        return subauxB - subauxA;
                    }
                    const compareVal = auxA[0].level_3.replaceAll(' ', '_').localeCompare(auxB[0].level_3.replaceAll(' ', '_'))
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else {
                    return this.sortDirection === "asc" ? valA.length - valB.length : valB.length - valA.length;
                }
            });
        },
        sortAllDocuments() {
            const documentsClassified = this.tax_documents.filter(localDoc => localDoc.prorate_accounts.length > 0 && !localDoc.cancelled)
            const documentsNotClassified = this.tax_documents.filter(localDoc => localDoc.prorate_accounts.length == 0 && !localDoc.cancelled)
            const documentsAnnulled = this.tax_documents.filter(localDoc => localDoc.cancelled)
            const orderedDocsClassified = this.sortPartiallyDocs(documentsClassified)
            const orderedDocsNotClassified = this.sortPartiallyDocs(documentsNotClassified)
            const orderedDocsAnnulled = this.sortPartiallyDocs(documentsAnnulled)
            this.localOrderedTaxDocuments = [...orderedDocsNotClassified, ...orderedDocsClassified, ...orderedDocsAnnulled]
        },
        changeOrderGeneric(column) {
            if (this.sortColumn != column) {
                this.sortDirection = "order"
                this.sortColumn = column;
            }
            this.changeDirectionData();
            this.sortAllDocuments();
        },
    },
    mounted() {
        this.changeOrderGeneric('amount')
    },
    props: ["tax_documents"],
    watch: {
        tax_documents() {
            this.searchFilter = ''
            this.sortColumn = ''
            this.sortDirection = ''
            this.changeOrderGeneric('amount')
        }
    }
}
</script>

<style lang="scss" scoped>
.container_table_main_table {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eaecf0;
    overflow-y: auto;
    max-height: 70vh;
    scrollbar-width: none;
}

.main_table {
    border-collapse: collapse;
    min-height: 10vh;
    max-height: 50vh;
}

.icon_svg {
    margin-bottom: -4px;
}

.counterpart_table_header {
    background-color: #eaecf0;
    height: 60px;
    width: 100%;
    padding: 12px 20px;
    align-items: center;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;

    .search_container {
        border-radius: 8px;
        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
        max-width: fit-content;

        .absolute-box {
            background-color: white;
            border-radius: 8px;

            .input-center {
                z-index: 2;
                border-width: 0;
                width: 300px;
                height: 35px;
                background-color: transparent;
            }

            .input-center:focus {
                outline: none;
                border-color: transparent;
                box-shadow: none;
            }

            .icon-right {
                height: 20px;
                right: 0px;
                left: auto;
            }
        }
    }
}

.color_gray_text {
    color: #475467;
}

.table_header_title {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fcfcfd;
    box-sizing: border-box;
    text-align: left;
    font-size: 12px;
}

.square_pill {
    position: relative;
    border-radius: 6px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
    justify-content: center;
    padding: 2px 4px;
    text-align: center;
    font-size: 12px;
    width: min-content;
    min-width: 4em;
}

.pill_sin_clasificar {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_mother_account {
    line-break: auto;
    display: block;
    color: #475467;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.grey_pill {
    background-color: #eaecf0;
    border: 1px solid #d0d5dd;
}

.white_pill {
    background-color: #FFF;
    border: 1px solid #D0D5DD;
}

.pill_clasificar {
    position: relative;
    box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fef3f2;
    border: 1px solid #fecdca;
    box-sizing: border-box;
    width: 103px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 4px;
    text-align: left;
    font-size: 12px;
    color: #b42318;
    font-family: Inter;
    font-weight: 600;
}

.row {
    border-top: 1px solid #eaecf0;
    margin-bottom: 10px;

    .text_format {
        color: var(--Gray-600, #475467);
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
    }

    td {
        vertical-align: middle;
    }
}
</style>